const SESSION_ID_KEY = 'hp_x_session_id';
const STATUS_ID_KEY = 'hp_x_session_status_id';
const ACTIVE_BUSINESS_ID_KEY = 'activeBusinessId';

export function setPersistedSessionHeaders(
  sessionId: string,
  statusId: string
) {
  sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  sessionStorage.setItem(STATUS_ID_KEY, statusId);
}

export function clearPersistedSessionHeaders() {
  sessionStorage.removeItem(SESSION_ID_KEY);
  sessionStorage.removeItem(STATUS_ID_KEY);
}

export function getPersistedSessionId(): string | null {
  return sessionStorage.getItem(SESSION_ID_KEY);
}

export function getPersistedStatusId(): string | null {
  return sessionStorage.getItem(STATUS_ID_KEY);
}

/**
 * Multi-business support (Phase 1) — per approved_architecture.md §4.3.
 * Persist/retrieve/clear the active business ID in sessionStorage so the
 * axios interceptor can attach X-Active-Business-Id to business-scoped
 * API requests.
 */
export function setPersistedActiveBusinessId(businessId: string): void {
  try {
    sessionStorage.setItem(ACTIVE_BUSINESS_ID_KEY, businessId);
  } catch {
    // sessionStorage unavailable — not fatal
  }
}

export function clearPersistedActiveBusinessId(): void {
  try {
    sessionStorage.removeItem(ACTIVE_BUSINESS_ID_KEY);
  } catch {
    // ignore
  }
}

export function getPersistedActiveBusinessId(): string | null {
  try {
    return sessionStorage.getItem(ACTIVE_BUSINESS_ID_KEY);
  } catch {
    return null;
  }
}
